/**
 * Enum for the search query field of the platformcatalogs search.
 */
export enum PlatformcatalogSearchQueryField {
  All = 'All',
  PlatformCatalogName = 'PlatformCatalogName',
  IndustryCatalogName = 'IndustryCatalogName',
  SupplierName = 'SupplierName',
  OrganizationName = 'OrganizationName',
}

/**
 * Enum for the search query filter of assigned industry catalogs to a platform catalog.
 *
 * This is more or less a subset of `PlatformcatalogSearchQueryField` without the
 * fields that are not related to industry catalogs.
 */
export enum AssignedIndustryCatalogSearchQueryField {
  All = 'All',
  IndustryCatalogName = 'IndustryCatalogName',
  SupplierName = 'SupplierName',
}
